import Swiper from "swiper";
import $ from 'jquery';
import Utils from "../../Utility/Utils";
import SubPage from "../../SubPage";
import CountryScoreCard from "../CountryScoreCard";

export default class MobileCountryDetailSlider {

    constructor(containerId, countryDetailPanel, worldMap, data) {
        this.containerId = containerId;
        this.countryDetailPanel = countryDetailPanel;
        this.worldMap = worldMap;
        this.data = data;
        this.swiper = null;
        this.panelListBtns = null

        if (this.data) {
            this.countryScoreCard = CountryScoreCard.getInstance(this.data)
        }

        this.slideNext = $('.country_detail_slider_footer .next_btn')
        this.slidePrev = $('.country_detail_slider_footer .prev_btn')

    }

    initSlider(region, countryName = null) {
        this.countries = this.data.filter((d) => d.Region == region)
        if (this.countries) {
            this.countries.forEach(region => {
                const total = region.Total.toFixed(1); // Ensures one decimal place
                const integerPart = Math.floor(total); // Gets the part before the decimal
                const decimalPart = (total % 1).toFixed(1).substring(1);
                const segmentsTotal = region ? region.Total : "N/A";
                const averages = Utils.getSegmentWiseAverage(region);

                $(this.containerId + ' .swiper-wrapper').append(`
                    <div class="swiper-slide country_slide scrollBar" >
                        <div class="countryItem active">
                            <div class="card">
                                <div class="contry_title">
                                    <img src="assets/images/Flags/${region.Flag}" alt="" class="flag">
                                    <h3 class="generic_title">${region.Country}</h3>
                                </div>

                                <div class="countryScore">
                                    <div class="point-block">
                                        <p class="third_title">$</p>
                                        <h3 class="point">${integerPart}</h3>
                                        <p class="decimal">${decimalPart}</p>
                                    </div>

                                    <button class="deepDiveBtn" data-country="${region.Country}">
                                        <p class="paragraph">Deep dive</p>
                                        <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.9988 5.99993L16.4295 10.5692M20.9988 5.99993L16.4295 1.43066M20.9988 5.99993H7.77042H1.15625" stroke="white" stroke-width="1.21847" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p class="paragraph segment_title">Breakdown of country’s potential productivity by pillar</p>
                        <ul class="segment-list">
                            <li>
                                <div class="context">
                                    <div class="dot"></div>
                                    <p class="paragraph">Labor and human capital</p>
                                </div>
                                <div class="score">$<span>${averages[0].value.toFixed(1)}</span></div> 
                            </li>
                            <li>
                                <div class="context">
                                    <div class="dot"></div>
                                    <p class="paragraph">Physical capital</p>
                                </div>
                                <div class="score">$<span>${averages[1].value.toFixed(1)}</span></div> 
                            </li>
                            <li>
                                <div class="context">
                                    <div class="dot"></div>
                                    <p class="paragraph">Social capital</p>
                                </div>
                                <div class="score">$<span>${averages[2].value.toFixed(1)}</span></div>    
                            </li>
                            <li>
                                <div class="context">
                                    <div class="dot"></div>
                                    <p class="paragraph">Natural capital</p>
                                </div>
                                <div class="score">$<span>${averages[3].value.toFixed(1)}</span></div>   
                            </li>
                            <li>
                                <div class="context">
                                    <div class="dot"></div>
                                    <p class="paragraph">Innovation and intangible capital</p>
                                </div>
                                <div class="score">$<span>${averages[4].value.toFixed(1)}</span></div>     
                            </li>
                            <li>
                                <div class="context">
                                    <div class="dot"></div>
                                    <p class="paragraph">Institutions</p>
                                </div>
                                <div class="score">$<span>${averages[5].value.toFixed(1)}</span></div>     
                            </li>
                        </ul>
                    </div>
                `)

                $('.country_detail_slider_footer .countryDetail_Mob-pagination').append(` 
                    <div class="swiper-pagination-bullet"></div>
                `)
            });

            this.swiper = new Swiper(this.containerId, {
                slidesPerView: 1,
                spaceBetween: 10,
                on: {
                    init: (instance) => {
                        const paginationBullets = document.querySelectorAll('.country_detail_slider_footer .countryDetail_Mob-pagination .swiper-pagination-bullet')
                        paginationBullets.forEach(b => b.classList.remove('active'))
                        paginationBullets[instance.activeIndex]?.classList.add('active')

                        this.handleDeepDiveBtn()
                    },
                    slideChange: (instance) => {
                        const paginationBullets = document.querySelectorAll('.country_detail_slider_footer .countryDetail_Mob-pagination .swiper-pagination-bullet')
                        paginationBullets.forEach(b => b.classList.remove('active'))
                        paginationBullets[instance.activeIndex]?.classList.add('active')
                    }
                }
            });

            setTimeout(() => {
                if (countryName) {
                    const countryIndex = this.countries.findIndex((region) => region.Country === countryName);
    
                    if (countryIndex !== -1) {
                        if(this.swiper){
                            this.swiper.slideTo(countryIndex);
                        }
                    }
                }
            }, 200)

            this.slideNext.on('click', () => {
                this.swiper.slideNext();
            });

            this.slidePrev.on('click', () => {
                this.swiper.slidePrev();
            });

            $('.country_detail_slider_footer .countryDetail_Mob-pagination .swiper-pagination-bullet').on('click', (e) => {
                const index = $(e.currentTarget).index();
                this.swiper.slideTo(index);
            })



        }


        this.countryDetailPanel.regionDropDown.dropdown('set selected', region)
        this.countryDetailPanel.regionDropDown.dropdown({
            onChange: (value, text, $selectedItem) => {
                this.updateSlider(value)
                this.worldMap.zoomToRegion(value)
            }
        })

    }

    static swiperSlideTo(i) {
        if (this.swiper != null) {
            this.swiper.slideTo(i)
        }
    }

    handleDeepDiveBtn() {
        this.panelListBtns = document.querySelectorAll('.mob_countryDetailSlider .swiper-slide .deepDiveBtn')

        this.panelListBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                SubPage.getInstance().showCountryScoreCardPage();

                if (this.countryScoreCard != null) {
                    this.countryScoreCard.updateCountryScore(btn.dataset.country)
                }
            })
        })
    }

    updateSlider(region) {
        this.swiper.destroy(true, true)
        $(this.containerId + ' .swiper-wrapper').empty()
        $('.country_detail_slider_footer .countryDetail_Mob-pagination').empty()
        this.initSlider(region)
    }
}   